// removed by extract-text-webpack-plugin
module.exports = {"header":"NewxGRiN13WGK9X6PpoIy","inner":"_2a0p34a4WvEW-jdmY6g5EG","filters":"_1cPUU2xAXduh_uTkJlOPMA","list-outer":"_13dOrcOcgJecX5yOu-UORn","list":"GnxdunbMghUYB6wsbDvfG","searching":"_3L5fomFa_7f1mrsTLlPaI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FeatureArticlesFilter/FeatureArticlesFilter.module.scss
// module id = 757
// module chunks = 0